import React from 'react';

const Divider = () => {
    return (
        <hr className="mt-2 mb-2 col s12" style={{border: '1px solid pink'}} />
    );
};

export default Divider;